// extracted by mini-css-extract-plugin
export default {"modal":"Modal-index__modal--PeeSS"};